import { Button, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import {  NotificationTemplateFilterFormFieldList, NotificationTemplateFilterFormValues } from 'features/notification/components/type';
import { useGetDropDownData } from 'features/notification/use-cases/get-common-api-data';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;

type UsersFilterFormProps = {
  formId: string;
  handleFilter: (values: NotificationTemplateFilterFormValues) => void;
  initialValues: NotificationTemplateFilterFormValues;
  closeModal?: () => void;
};

export const NotificationTemplateFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: UsersFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<NotificationTemplateFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();


   const { data:notificationType } = useGetDropDownData({
        flag: "announcementtype",
        searchId:0,
        SearchKey: ""
        },{
    refetchOnWindowFocus: false,
     refetchOnMount: false});

  const onReset = () => {
    form.resetFields();
    handleFilter(initialValues);
  };

  const onFinish = (formValues: NotificationTemplateFilterFormValues) => {
    handleFilter(formValues);
    closeModal?.();
  };

  return (
    
    <Form<NotificationTemplateFilterFormValues>
      id={formId}
      name={formId}
      className='filters-form'
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper style={{width:'100%'}}>
        <StandardItemsWrapper style={{width:'100%'}}>
          {/* <div className='invoice_list' style={{width:'100%'}}> */}
       
          <Form.Item<NotificationTemplateFilterFormValues>
          label="Type"
          name={NotificationTemplateFilterFormFieldList.ANNOUNCEMENTTYPEID}
        >
          <Select placeholder="Select Type" 
           style={{ width: "200px" }}
           options={notificationType?.notificationDropDownList?.map((res: any) => ({
                                        label: res.title,
                                        value: res.id
                                    }))}
          
          allowClear>
      
          </Select>
        </Form.Item>

           <Form.Item<NotificationTemplateFilterFormValues>
            label={'Title'}
            name={NotificationTemplateFilterFormFieldList.TITLE}
          >
            <Input
              placeholder={'Enter Title'}
            />
          </Form.Item>

          {screens.lg && (
        <ContentFilters.ButtonsWrapper >
          <Button type='primary' htmlType='submit'>
            {t('common.buttons.filter', { count: 1 })}
          </Button>
          <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
        </ContentFilters.ButtonsWrapper>
      )}
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>  
    </Form>
  );
};
